import { render } from "./PrescriptionDetailsTab.vue?vue&type=template&id=6c5fb9f9"
import script from "./PrescriptionDetailsTab.vue?vue&type=script&lang=js"
export * from "./PrescriptionDetailsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__